"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.filesLens = exports.moveReasonsLens = exports.copyReasonsLens = exports.permissionsErrorLens = exports.moveStatusLens = exports.copyStatusLens = exports.initialState = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const FolderPermissionChecksActionTypes = require("../../actionTypes/folders/permissionChecks");
const folderContentInitialState = {
    folderStructureStatus: 'STANDBY',
    folderStructureError: undefined,
    expanded: [],
    fetched: [],
    folders: [],
    loadingFolder: [],
    selected: ''
};
exports.initialState = {
    checkCopyStatus: 'STANDBY',
    checkMoveStatus: 'STANDBY',
    copyReasons: [],
    moveReasons: [],
    files: [],
    error: undefined,
    folderContent: folderContentInitialState
};
const folderStructureLens = monocle.Lens.fromProp('folderContent');
// Permissions checks related lenses
exports.copyStatusLens = monocle.Lens.fromProp('checkCopyStatus');
exports.moveStatusLens = monocle.Lens.fromProp('checkMoveStatus');
exports.permissionsErrorLens = monocle.Lens.fromProp('error');
exports.copyReasonsLens = monocle.Lens.fromProp('copyReasons');
exports.moveReasonsLens = monocle.Lens.fromProp('moveReasons');
exports.filesLens = monocle.Lens.fromProp('files');
const reducer = (state, action) => {
    switch (action.type) {
        case FolderPermissionChecksActionTypes.CHECK_COPY_REQUEST: {
            return fp.function.compose(exports.copyStatusLens.set('CHECKING'), exports.permissionsErrorLens.set(undefined))(state);
        }
        case FolderPermissionChecksActionTypes.CHECK_COPY_FAILED: {
            return fp.function.compose(exports.copyStatusLens.set('FAILED'), exports.permissionsErrorLens.set(action.payload.error))(state);
        }
        case FolderPermissionChecksActionTypes.CHECK_COPY_SUCCESS: {
            return fp.function.compose(exports.copyStatusLens.set('CHECKED'), folderStructureLens.modify(() => {
                return Object.assign(Object.assign({}, state.folderContent), { fetched: state.folderContent.fetched.concat(action.payload.content.rootIdentifier), folders: state.folderContent.folders.concat(action.payload.content.folders), loadingFolder: state.folderContent.loadingFolder.filter((x) => x !== action.payload.content.rootIdentifier) });
            }))(state);
        }
        case FolderPermissionChecksActionTypes.CHECK_MOVE_REQUEST: {
            return fp.function.compose(exports.moveStatusLens.set('CHECKING'), exports.permissionsErrorLens.set(undefined))(state);
        }
        case FolderPermissionChecksActionTypes.CHECK_MOVE_FAILED: {
            return fp.function.compose(exports.moveStatusLens.set('FAILED'), exports.permissionsErrorLens.set(action.payload))(state);
        }
        case FolderPermissionChecksActionTypes.CHECK_MOVE_SUCCESS: {
            return fp.function.compose(exports.moveStatusLens.set('CHECKED'), exports.moveReasonsLens.set(action.payload.reasons || []), exports.filesLens.set(action.payload.resources))(state);
        }
        case FolderPermissionChecksActionTypes.RESET_CHECKS: {
            return Object.assign({}, exports.initialState);
        }
        default:
            return state;
    }
};
exports.reducer = reducer;
//# sourceMappingURL=permissionChecks.js.map